export default [
  {
    path: "usuarios",
    name: "users",
    redirect: { name: "users-list" },
    children: [
      {
        path: "",
        name: "users-list",
        component: () => import("@/modules/users/views/UsersList.vue"),
      },
      {
        path: "sellers",
        name: "users-sellers-list",
        component: () => import("@/modules/users/views/UsersSellersList.vue"),
      },
      {
        path: "ver/:id",
        name: "users-show",
        redirect: { name: "users-show-client-portfolio" },
        component: () => import("@/modules/users/views/UsersShow.vue"),
        children: [
          {
            path: "cartera-clientes",
            name: "users-show-client-portfolio",
            component: () =>
              import("@/modules/users/views/UsersShowClientPortfolio.vue"),
          },
          {
            path: "listado-visitas",
            name: "users-show-visit-list",
            component: () =>
              import("@/modules/users/views/UsersShowVisitsList.vue"),
          },
          {
            path: "rutas-clientes",
            name: "users-show-client-routes",
            component: () =>
              import("@/modules/users/views/UsersShowClientRoutes.vue"),
          },
          {
            path: "avances-metas",
            name: "users-show-progress-goals",
            component: () =>
              import("@/modules/users/views/UsersShowProgressGoals.vue"),
          },
        ],
      },
    ],
  },
];
